import { ColumnTable } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';

export default function useColumns(
  actionsColumns: ColumnTable[],
): ColumnTable[] {
  const { t } = useTranslation(TranslationsKeys.CONFIGURATION_INSTITUTIONS);
  return [
    {
      columnName: 'name',
      headerText: t('table.name'),
      tdClassName: 'text-left',
      thClassName: 'text-left',
    },
    {
      columnName: 'code',
      headerText: t('table.code'),
      tdClassName: 'text-left',
      thClassName: 'text-left',
      cellFormat: ({ value }) => value || '-',
    },
    {
      columnName: 'country',
      headerText: t('table.country'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: ({ value }) => (value ? value?.name : '-'),
    },
    ...actionsColumns,
  ];
}
